import React from 'react';
import HeroHeading from './HeroHeading';
import BotInfoForm from './BotInfoForm';
import lightBg from '../../assets/lightBg.svg';
import darkBg from '../../assets/darkBg.svg';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface BotBuilderHeroProps {
  isAuthenticated: boolean;
}

const BotBuilderHero = ({ isAuthenticated }: BotBuilderHeroProps) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme);
  
  const backgroundStyle = {
    backgroundImage: `url(${isDarkMode ? darkBg : lightBg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };
  
  return (
    <section className="w-full pt-5 sm:pt-10 pb-0" style={backgroundStyle}>
      <img src='/bot-builder.svg' alt="Bot Builder" className="lg:hidden w-auto h-28 mb-5 ml-4 object-cover" />
      <div className="mx-auto">
        <HeroHeading />
        <BotInfoForm isAuthenticated={isAuthenticated} />
      </div>
    </section>
  );
};

export default BotBuilderHero;
